var winWidth = document.documentElement.offsetWidth || document.body.offsetWidth;
winWidth = winWidth < 1366 ? 1366 : winWidth;
var oHtml = document.getElementsByTagName('html')[0];
oHtml.style.fontSize = 16 * winWidth / 1920 + 'px';

window.addEventListener('resize', function () {
    var winWidth = document.documentElement.offsetWidth || document.body.offsetWidth;
    winWidth = winWidth < 1366 ? 1366 : winWidth;
    var oHtml = document.getElementsByTagName('html')[0];
    oHtml.style.fontSize = 16 * winWidth / 1920 + 'px';
})


// WEBPACK FOOTER //
// ./src/utils/flexible.js